import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/drag-icon.svg'
import _imports_1 from '@/assets/images/rv/warning.svg'


const _withScopeId = n => (_pushScopeId("data-v-aaae5bd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-t-8 bg-fff search-main" }
const _hoisted_2 = { class: "d-f" }
const _hoisted_3 = { class: "d-f flex-d-c m-l-16 flex-w-auto" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Release Batch Name", -1))
const _hoisted_5 = { class: "d-f flex-d-c m-l-16 flex-w-auto" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Release AT", -1))
const _hoisted_7 = {
  class: "d-f m-l-12 align-e",
  style: {"padding-bottom":"6px"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Manual Release")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_10 = {
  class: "d-f flex-d-c m-l-16 flex-w-auto",
  style: {"flex":"1.5"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-text-12" }, "Release To", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-w-auto" }, null, -1))
const _hoisted_13 = {
  class: "d-f flex-w-auto",
  style: {"margin":"10px 16px 0 16px","justify-content":"space-between"}
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Sales Measure Summary: ", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("View")
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "m-l-16",
  style: {"color":"red"}
}, "To Be Generated", -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Generate")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("PDF Preview")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Cover Page Edit")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Download")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Send")
const _hoisted_26 = { class: "m-t-8 bg-fff main flex-w-auto" }
const _hoisted_27 = { class: "title d-f align-c" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Selected Program ")
const _hoisted_29 = { class: "table-container" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "trigger cursor-p",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_31 = { class: "btns m-t-8" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Remove")
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Sales Measure Summary not generated yet, are you sure you want to send?", -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Send")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmIcon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "noticeIcon"
  }),
  /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px"} }, "Tips:")
], -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Confirm")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The program will be visible to all dealer network", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadcrumb = _resolveComponent("breadcrumb")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_AddProgram = _resolveComponent("AddProgram")!
  const _component_SalesMeasureDrawer = _resolveComponent("SalesMeasureDrawer")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_main_wrapper = _resolveComponent("main-wrapper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_main_wrapper, { className: "p-l-r-10" }, {
      header: _withCtx(() => [
        (_ctx.showScrollContainer)
          ? (_openBlock(), _createBlock(_component_breadcrumb, {
              key: 0,
              className: "",
              dataSource: [{ name: 'Release Setting' }]
            }))
          : (_openBlock(), _createBlock(_component_breadcrumb, {
              key: 1,
              className: "d-f justify-b",
              dataSource: [{ name: 'Release Setting' }]
            }))
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_a_input, {
                value: _ctx.validateData.releaseBatchName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.validateData.releaseBatchName) = $event)),
                placeholder: "政策发布中文名称 / Release Batch EN Name"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_a_date_picker, {
                style: { width: 100 + '%' },
                value: _ctx.validateData.releaseAt,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.validateData.releaseAt) = $event)),
                "disabled-date": _ctx.disabledDateReleaseAt,
                "disabled-time": _ctx.disabledDateTime,
                format: "YYYY-MM-DD HH:00:00",
                "show-time": { hideDisabledOptions: true, format: 'HH' },
                onChange: _ctx.handlerDateChange,
                valueFormat: "YYYY-MM-DD HH"
              }, null, 8, ["value", "disabled-date", "disabled-time", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_checkbox, {
                checked: _ctx.validateData.manualRelease,
                "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.validateData.manualRelease) = $event)),
                onChange: _ctx.handlerCheckboxChange
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["checked", "onChange"])
            ]),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_a_checkbox_group, {
                value: _ctx.validateData.releaseTo.split('&'),
                style: {"margin-top":"3px"},
                onChange: _ctx.handlerReleaseToChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_checkbox, { value: "External" }),
                  _createElementVNode("a", {
                    class: "line-release",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toReleasePage('External')))
                  }, "External Release"),
                  _createVNode(_component_a_checkbox, {
                    value: "Internal",
                    style: {"margin-left":"15px"}
                  }),
                  _createElementVNode("a", {
                    class: "line-release",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toReleasePage('Internal')))
                  }, "Internal Release")
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", null, [
              (_ctx.smlStatus !== -1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _hoisted_15,
                    (_ctx.smlStatus === 1)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          type: "link",
                          onClick: _ctx.handleViewClick
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, _hoisted_19)),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      class: "m-l-16",
                      onClick: _ctx.getSmlGenerated
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_a_button, {
                class: "m-l-16",
                onClick: _ctx.handlerSaveClick,
                disabled: _ctx.reStatus === 'Discard' || _ctx.reStatus === 'Released'
              }, {
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_a_button, {
                class: "m-l-16",
                onClick: _ctx.handlerPdfPreviewClick,
                disabled: _ctx.reStatus === 'Discard'
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_a_button, {
                class: "m-l-16",
                onClick: _ctx.hanledPdfCoverPageClick,
                disabled: _ctx.reStatus === 'Discard' || _ctx.reStatus === 'Released'
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_a_button, {
                class: "m-l-16",
                onClick: _ctx.handleWordingDownload,
                disabled: _ctx.reStatus === 'Discard'
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_a_button, {
                class: "m-l-16",
                onClick: _ctx.handlerSendClick,
                disabled: !_ctx.validateData.manualRelease || _ctx.reStatus === 'Discard' || _ctx.reStatus === 'Released'
              }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(_component_a_badge, {
              count: _ctx.programs.length,
              class: "badge"
            }, null, 8, ["count"])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_a_table, {
              dataSource: _ctx.programs,
              class: "default-self-table-text",
              columns: _ctx.columns,
              scroll: { y: 400, x: 1000 },
              "row-selection": _ctx.rowSelection,
              rowKey: (item, index) => index,
              rowClassName: (record, index) => (index % 2 === 1 ? 'table-striped' : null),
              pagination: false
            }, {
              isAllDealersVisible: _withCtx(({ record }) => [
                _createVNode(_component_a_checkbox, {
                  value: record.isAllDealersVisible,
                  "onUpdate:value": ($event: any) => ((record.isAllDealersVisible) = $event),
                  checked: record.isAllDealersVisible,
                  "onUpdate:checked": ($event: any) => ((record.isAllDealersVisible) = $event),
                  onChange: ($event: any) => (_ctx.handleAllDealerChange(record)),
                  disabled: record.status === 'Released' || record.status === 'Revised'
                }, null, 8, ["value", "onUpdate:value", "checked", "onUpdate:checked", "onChange", "disabled"])
              ]),
              programFromDate: _withCtx(({ text }) => [
                _createTextVNode(_toDisplayString(text ? _ctx.moment(text).format('YYYY-MM-DD') : text), 1)
              ]),
              programToDate: _withCtx(({ text }) => [
                _createTextVNode(_toDisplayString(text ? _ctx.moment(text).format('YYYY-MM-DD') : text), 1)
              ]),
              resetFromDate: _withCtx(({ record }) => [
                _createVNode(_component_a_date_picker, {
                  style: {"width":"100%"},
                  disabled: !record.dummy,
                  "disabled-date": (time) => _ctx.disabledDate(time, record.fromDate),
                  placeholder: "Select Time",
                  value: record.resetFromDate,
                  "onUpdate:value": ($event: any) => ((record.resetFromDate) = $event),
                  format: "YYYY-MM-DD",
                  valueFormat: "YYYY-MM-DD"
                }, null, 8, ["disabled", "disabled-date", "value", "onUpdate:value"])
              ]),
              rowSet: _withCtx(() => [
                _hoisted_30
              ]),
              _: 1
            }, 8, ["dataSource", "columns", "row-selection", "rowKey", "rowClassName"]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_a_button, {
                onClick: _ctx.handlerAddClick,
                disabled: _ctx.reStatus === 'Discard' || _ctx.reStatus === 'Released'
              }, {
                default: _withCtx(() => [
                  _hoisted_32
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]),
              _createVNode(_component_a_button, {
                class: "m-l-16",
                onClick: _ctx.handlerRemoveClick,
                disabled: _ctx.reStatus === 'Discard' || _ctx.reStatus === 'Released'
              }, {
                default: _withCtx(() => [
                  _hoisted_33
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ])
          ])
        ]),
        _createVNode(_component_AddProgram, {
          visible: _ctx.visibleAddProgramModal,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visibleAddProgramModal) = $event)),
          dataSource: _ctx.programList,
          onConfirm: _ctx.handlerConfirmClick
        }, null, 8, ["visible", "dataSource", "onConfirm"]),
        _createVNode(_component_SalesMeasureDrawer, {
          visible: _ctx.visibleSalesMeasureDrawer,
          "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visibleSalesMeasureDrawer) = $event)),
          batchId: _ctx.id,
          onDeleteSml: _cache[7] || (_cache[7] = (status) => (_ctx.smlStatus = status))
        }, null, 8, ["visible", "batchId"]),
        _createVNode(_component_a_modal, {
          visible: _ctx.checkGenerateVisible,
          "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.checkGenerateVisible) = $event)),
          title: "Warning"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_a_button, {
              key: "back",
              onClick: _ctx.checkCancel
            }, {
              default: _withCtx(() => [
                _hoisted_35
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_a_button, {
              key: "submit",
              type: "primary",
              onClick: _ctx.send
            }, {
              default: _withCtx(() => [
                _hoisted_36
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _hoisted_34
          ]),
          _: 1
        }, 8, ["visible"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      centered: "",
      visible: _ctx.allDealerVisiable,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.allDealerVisiable) = $event)),
      onCancel: _ctx.closeDealerModal,
      bodyStyle: {
      minHeight: '180px'
    }
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.closeDealerModal
        }, {
          default: _withCtx(() => [
            _hoisted_38
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_37,
        _hoisted_39
      ]),
      _: 1
    }, 8, ["visible", "onCancel"])
  ], 64))
}